import { HttpClient, HttpEventType } from '@angular/common/http';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { fileUploadService } from 'src/app/shared/services/fileUpload.service';
import { attachment } from './attachment.model';

@Component({
    selector: 'app-attachment',
    templateUrl: './attachment.component.html',
    styleUrls: ['./attachment.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AttachmentComponent {
  uploadProgress: number;
  uploadSub: Subscription;
  apiHost: string = environment.apiHost;
  isLoading: boolean = false;
  counter: number = -1;
  fileName: string[] = [];
  fileUrl: string[] = [];
  attachments: attachment[] = [];

  constructor(private fileUploadService: fileUploadService) {}

  async onFileSelected(event) {
    const file: File = event.target.files[0];

    if (file) {
      this.counter = this.counter + 1;
      this.isLoading = true;
      this.fileUrl[this.counter] = await this.fileUploadService.uploadFile(
        file,
        file.name,
        'attachments'
      );
      this.fileName[this.counter] = file.name;
      this.isLoading = false;
    }
  }

  clearAttachments() {
    this.attachments = [];
    this.fileName = [];
    this.counter = -1;
  }

  getAttachments(): attachment[] {
    let counter: number = 0;
    this.attachments = [];
    this.fileName.forEach((a) => {
      let attach: attachment = new attachment();
      attach.fileName = a;
      attach.fileUrl = this.fileUrl[counter];
      counter = counter + 1;
      this.attachments.push(attach);
    });
    return this.attachments;
  }
}
